// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { StateMapDisk } from '../tbs/state-map-disk.js';


export class StateMap implements flatbuffers.IUnpackableObject<StateMapT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StateMap {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStateMap(bb:flatbuffers.ByteBuffer, obj?:StateMap):StateMap {
  return (obj || new StateMap()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStateMap(bb:flatbuffers.ByteBuffer, obj?:StateMap):StateMap {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StateMap()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

id():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('-1');
}

dname():string|null
dname(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dname(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

bio():string|null
bio(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
bio(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

disk():StateMapDisk {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : StateMapDisk.Cloud;
}

published():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

static startStateMap(builder:flatbuffers.Builder) {
  builder.startObject(5);
}

static addId(builder:flatbuffers.Builder, id:bigint) {
  builder.addFieldInt64(0, id, BigInt('-1'));
}

static addDname(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dnameOffset, 0);
}

static addBio(builder:flatbuffers.Builder, bioOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, bioOffset, 0);
}

static addDisk(builder:flatbuffers.Builder, disk:StateMapDisk) {
  builder.addFieldInt8(3, disk, StateMapDisk.Cloud);
}

static addPublished(builder:flatbuffers.Builder, published:boolean) {
  builder.addFieldInt8(4, +published, +false);
}

static endStateMap(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createStateMap(builder:flatbuffers.Builder, id:bigint, dnameOffset:flatbuffers.Offset, bioOffset:flatbuffers.Offset, disk:StateMapDisk, published:boolean):flatbuffers.Offset {
  StateMap.startStateMap(builder);
  StateMap.addId(builder, id);
  StateMap.addDname(builder, dnameOffset);
  StateMap.addBio(builder, bioOffset);
  StateMap.addDisk(builder, disk);
  StateMap.addPublished(builder, published);
  return StateMap.endStateMap(builder);
}

unpack(): StateMapT {
  return new StateMapT(
    this.id(),
    this.dname(),
    this.bio(),
    this.disk(),
    this.published()
  );
}


unpackTo(_o: StateMapT): void {
  _o.id = this.id();
  _o.dname = this.dname();
  _o.bio = this.bio();
  _o.disk = this.disk();
  _o.published = this.published();
}
}

export class StateMapT implements flatbuffers.IGeneratedObject {
constructor(
  public id: bigint = BigInt('-1'),
  public dname: string|Uint8Array|null = null,
  public bio: string|Uint8Array|null = null,
  public disk: StateMapDisk = StateMapDisk.Cloud,
  public published: boolean = false
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const dname = (this.dname !== null ? builder.createString(this.dname!) : 0);
  const bio = (this.bio !== null ? builder.createString(this.bio!) : 0);

  return StateMap.createStateMap(builder,
    this.id,
    dname,
    bio,
    this.disk,
    this.published
  );
}
}
